export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8080/api/v1',
  apiTimeout: Number(import.meta.env.VITE_API_TIMEOUT ?? 30_000),
  appName: import.meta.env.VITE_APP_NAME ?? 'DB Scaffolding',
  appVersion: import.meta.env.VITE_APP_VERSION ?? '1.0.0',
  enableDevtools: import.meta.env.VITE_ENABLE_DEVTOOLS === 'true',
  useMockApi: import.meta.env.VITE_USE_MOCK_API === 'true',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  mode: import.meta.env.MODE,
} as const;
